import { z } from 'zod';

export const IncidentSchema = z.object({
  id: z.string().or(z.number()),
  date: z.string(),
  narrative: z.string().optional(),
  longitude: z.number(),
  latitude: z.number(),
  name: z.string().optional(),
});

export type Incident = z.infer<typeof IncidentSchema>;

export const IncidentsResponseSchema = z.object({
  incidents: z.array(IncidentSchema),
});
